<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="20px"
    height="20px"
    style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g>
      <path
        style="opacity:0.95"
        fill="#96a5b2"
        d="M -0.5,-0.5 C 6.16667,-0.5 12.8333,-0.5 19.5,-0.5C 19.5,6.16667 19.5,12.8333 19.5,19.5C 12.8333,19.5 6.16667,19.5 -0.5,19.5C -0.5,12.8333 -0.5,6.16667 -0.5,-0.5 Z M 1.5,0.5 C 7.09345,0.193427 12.5934,0.526761 18,1.5C 18.8056,7.08375 18.6389,12.5838 17.5,18C 11.9162,18.8056 6.41625,18.6389 1,17.5C 0.215259,11.7507 0.381926,6.08402 1.5,0.5 Z"
      />
    </g>
    <g>
      <path
        style="opacity:1"
        fill="#ed4342"
        d="M 3.5,3.5 C 7.55461,3.17575 11.5546,3.50909 15.5,4.5C 13.5,4.83333 11.5,5.16667 9.5,5.5C 7.04775,5.46093 5.04775,4.79426 3.5,3.5 Z"
      />
    </g>
    <g>
      <path
        style="opacity:1"
        fill="#96a5b2"
        d="M 3.5,8.5 C 7.55461,8.17575 11.5546,8.50909 15.5,9.5C 13.5,9.83333 11.5,10.1667 9.5,10.5C 7.04775,10.4609 5.04775,9.79426 3.5,8.5 Z"
      />
    </g>
    <g>
      <path
        style="opacity:1"
        fill="#3bb46d"
        d="M 3.5,13.5 C 7.55461,13.1758 11.5546,13.5091 15.5,14.5C 13.5,14.8333 11.5,15.1667 9.5,15.5C 7.04775,15.4609 5.04775,14.7943 3.5,13.5 Z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "plateAll"
};
</script>
<style scoped lang="scss"></style>
